import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import App from './App';
import { correcttrackStore } from './store/correcttrackStore';
import { Provider } from 'react-redux';
import { injectStoreForAuth } from './auth/AuthService';
import { injectStore } from './api/CustomAxios';
import i18n, { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './i18n';
import { setLanguage } from './store/correcttrackSlice';
import { correctTrackTheme } from './theme';

injectStoreForAuth(correcttrackStore);
injectStore(correcttrackStore);

// Resolve initial language: persisted Redux value wins; otherwise fall back to
// what i18n detected from navigator.language (filtered to supported locales).
const persistedLanguage = correcttrackStore.getState().correcttrack?.language;
if (persistedLanguage && SUPPORTED_LOCALES.includes(persistedLanguage)) {
    i18n.changeLanguage(persistedLanguage);
} else {
    correcttrackStore.dispatch(setLanguage(i18n.language || DEFAULT_LOCALE));
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <BrowserRouter>
        <Provider store={correcttrackStore}>
            <ThemeProvider theme={correctTrackTheme}>
                <App />
            </ThemeProvider>
        </Provider>
    </BrowserRouter>);
